const isFeatureEnabled = (envKey: string) => process.env[envKey] === 'true';

const bankFeatureFlags = {
  isBankModuleEnabled: isFeatureEnabled('REACT_APP_BANK_MODULE_ENABLED'),
  isBankTransactionsEnabled: isFeatureEnabled(
    'REACT_APP_BANK_MODULE_TRANSACTIONS_ENABLED'
  ),
  isBankStatementsEnabled: isFeatureEnabled(
    'REACT_APP_BANK_MODULE_STATEMENTS_ENABLED'
  ),
};

const creditFeatureFlags = {
  isCreditModuleEnabled: isFeatureEnabled('REACT_APP_CREDIT_MODULE_ENABLED'),
};

const config = {
  api: process.env.REACT_APP_API_BASEURL || '',
  dateFormat: 'DD MMM YYYY',
  dateTimeFormat: 'DD MMM YYYY HH:mm',
  ...bankFeatureFlags,
  ...creditFeatureFlags,
};

export default config;
